import { DIALOG_HIDE, DIALOG_SHOW } from '../../actions/constants/types';

function dialogsReducer(state = {}, action) {
  switch (action.type) {
    case DIALOG_SHOW:
      return {
        ...state,
        [action.identifier]: {
          isVisible: true,
        },
      };
    case DIALOG_HIDE:
      return {
        ...state,
        [action.identifier]: {
          isVisible: false,
        },
      };
    default:
      return state;
  }
}

export default dialogsReducer;
